import { createAction as ngrxCreateAction } from "@ngrx/store";

export const CALL = "[Navigation] Call";
export const SWITCH = "[Navigation] Switch";
export const FORWARD = "[Navigation] Forward";
export const BACK = "[Navigation] Back";
export const DIALOG = "[Navigation] Dialog";
export const VALIDATE_SCREEN = "[Feature] Validate Screen";

export const navigateByCallAction = ngrxCreateAction(CALL, payload => payload);
export const navigateBySwitchAction = ngrxCreateAction(
  SWITCH,
  payload => payload
);
export const navigateByForwardAction = ngrxCreateAction(
  FORWARD,
  payload => payload
);
export const navigateByBackAction = ngrxCreateAction(BACK, payload => payload);
export const navigateByDialogAction = ngrxCreateAction(DIALOG, payload => payload);
export const validateScreenAction = ngrxCreateAction(VALIDATE_SCREEN, payload => payload);
